import { BillStatus } from '@features/bills/enums/billStatus'

import { BillsTableRow } from '../../../types/billsTableRow'
import { billStatusToActionTypes } from '../constants/billStatusToActionTypes'
import { BillsTableActionType } from '../enums/billsTableActionType'
import { BillsTableAction } from '../types/billsTableAction'
import { useCreateCreditNoteAction } from './actions/useCreateCreditNoteAction'
import { useDuplicateBillAction } from './actions/useDuplicateBillAction'
import { useEditBillAction } from './actions/useEditBillAction'
import { useRegisterPaymentAction } from './actions/useRegisterPaymentAction'
import { useVoidBillAction } from './actions/useVoidBillAction'
import { useVoidPaymentAction } from './actions/useVoidPaymentAction'

export const useBillsTableActions = (row: BillsTableRow): BillsTableAction[] => {
  const actionsByType: Record<BillsTableActionType, BillsTableAction> = {
    [BillsTableActionType.CreateCreditNote]: useCreateCreditNoteAction(row),
    [BillsTableActionType.Duplicate]: useDuplicateBillAction(row),
    [BillsTableActionType.Edit]: useEditBillAction(row),
    [BillsTableActionType.RegisterPayment]: useRegisterPaymentAction(row),
    [BillsTableActionType.Void]: useVoidBillAction(row),
    [BillsTableActionType.VoidPayment]: useVoidPaymentAction(row),
  }

  if (row.derivedStatus === BillStatus.All) {
    return []
  }

  // Run-time safety check for unknown statuses
  const actionTypes = billStatusToActionTypes[row.derivedStatus] ?? []

  return actionTypes.map((actionType) => actionsByType[actionType])
}
